module.exports = __webpack_public_path__ + "static/media/8_4.2be286a0.jpg";